import { render, staticRenderFns } from "./Signup-modal.vue?vue&type=template&id=f0901ed6&scoped=true&"
import script from "./Signup-modal.vue?vue&type=script&lang=js&"
export * from "./Signup-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0901ed6",
  null
  
)

export default component.exports